import Routes from '../../../routes';
import { ScenarioMember } from '../../../shared/queries/scenarios';
import { GridMode } from '../../../shared/gridEdit/useEditableGridLogic';
import { toSearchString } from '../../../shared/urlUtils';

import { CUSTOM_LINK_CLASS_NAME } from '../../../shared/CustomLinksHandler.component';


type ObligationCompanyCodeCellRendererProps = {
  data: ScenarioMember,
  context: {
    scenarioId: number,
    mode: GridMode,
  }
}


const ObligationCompanyCodeCellRenderer = ({ data, context }: ObligationCompanyCodeCellRendererProps) => {
  const { companyCode } = data;
  const { scenarioId, mode } = context;
  return mode === GridMode.View
    ? (
      `<a
        class="${CUSTOM_LINK_CLASS_NAME}"
        href="${Routes.scenarios.rules.OBLIGATIONS.replace(/:scenarioId/, String(scenarioId))}?${toSearchString({ companyCode })}"
      >${companyCode}</a>`
    )
    : companyCode;
};

export default ObligationCompanyCodeCellRenderer;
